import { IAdapter, IAdapterData } from "@/entities";

export class Adapter implements IAdapter {
  readonly id?: number;
  readonly name?: string;
  readonly code?: string;
  readonly assignable?: boolean;
  $isDisabled: boolean;

  constructor(data: IAdapterData) {
    this.id = data.id;
    this.name = data.name;
    this.code = data.code;
    this.assignable = data.assignable;
    this.$isDisabled = false;
  }
}
